import Http from '../http'

export default {

  index(event_id) {
    return Http.get(`/event_expenses`, {params: {event_id: event_id}})
  },

}